module.exports = __webpack_public_path__ + "img/brand_bg.c5f1ad3f.svg";